import { useCallback } from 'react';
import { useStripeSessionUrlMutation } from 'shared/hooks/queries/use-stripe-session-url-mutation';
import { PriceInterval } from 'shared/types/price';

export const useRedirectToStripeUrlOrStartTrial = () => {
  const { mutateAsync, isPending } = useStripeSessionUrlMutation();

  const redirectOrStartTrial = useCallback(
    async ({
      interval,
      discountCode,
    }: {
      interval: PriceInterval;
      discountCode?: string;
    }): Promise<void | boolean> => {
      const { trialHasStarted, sessionUrl } = await mutateAsync({
        interval,
        discountCode,
      });

      if (sessionUrl) {
        window.location.href = sessionUrl;
        // prevent loading-state to change when the browser is slow
        return new Promise(() => {});
      }

      return trialHasStarted;
    },
    [mutateAsync],
  );

  return {
    redirectOrStartTrial,
    isLoading: isPending,
  };
};
